module.exports = __webpack_public_path__ + "static/media/EA.32312f8f.svg";